import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'roadmap',
    templateUrl: './roadmap.component.html'
})
export class RoadmapComponent implements OnInit, OnDestroy {
    
  roadMaps: any[] = [];
  filteredRoadMaps: any[] = [];
  filterList: any[] = [];
  allFilterIsActive: boolean = false;
  filter: any[] = [];
  completed: any[] = [];
  expected: any[] = [];
  ideas: any[] = [];

  constructor() {
  }

  filterUpdated(index: number = 0) {
    this.allFilterIsActive = false;
    this.filteredRoadMaps = [];
    this.filterList[index].isClicked = !this.filterList[index].isClicked;
    this.filterList.forEach(function (item, loopIndex) {
      if (loopIndex != index) {
        item.isClicked = false;
      }
    });
    if (this.filterList[index].isClicked) {
      this.filteredRoadMaps = this.filterList[index].data;
    }
    if (this.filterList.every(x => x.isClicked == false)) {
      this.filteredRoadMaps = this.roadMaps;
    }
  }

  ngOnInit() {
    
    this.roadMaps = [

      {
        status: 'Completed',
        monthAndYear: '01/08',
        year: '2018',
        title: 'PAYG Portfolio',
        imageUrl: '/images/iStock-1.jpg',
        datePosted: '20/09/2018',
        description: 'A summary of your PAYG estate, providing key metrics to help you manage your scheme(s) more effectively.'
      },
      {
        status: 'Partially completed',
        monthAndYear: '01/08',
        year: '2018',
        title: 'Individual Consumer View',
        imageUrl: '/images/iStock-customer-service.jpg',
        datePosted: '20/09/2018',
        description: 'Want to know about your customes accounts, visit this page. It allows you to see key points of information and history such as Account Balance, Payments and Bills. PAYG consumers first. Billing consumer information can be seen here later, expected soon.'
      },
      {
        status: 'Completed',
        monthAndYear: '01/08',
        year: '2018',
        title: 'Issues - PAYG',
        imageUrl: '/images/iStock--Double-Thermometer.jpg',
        datePosted: '20/09/2018',
        description: 'Here is where we are working to identify possible concerns on your PAYG schemes. This could help you save money, help your customers have a better service and reduce risks.'
      },
      {
        status: 'Completed',
        monthAndYear: '01/08',
        year: '2018',
        title: 'Roadmap',
        imageUrl: '/images/iStock-1-city-apartments.jpg',
        datePosted: '20/09/2018',
        description: 'Visit here, we\'re going to let you know what we\'ve delivered, what we\'re working to deliver and future thoughts.Your feedback and input would be very welcome.'
      },
      {
        status: 'Expected',
        monthAndYear: '01/02',
        year: '2019',
        title: 'Billing Portfolio',
        imageUrl: '/images/iStock--city-apartments.jpg',
        datePosted: '20/09/2018',
        description: 'A summary of your Billing estate, providing key metrics to help you manage your scheme(s) more effectively.'
      },
      {
        status: 'Expected',
        monthAndYear: '01/02',
        year: '2019',
        title: 'Issues - Billing',
        imageUrl: '/images/iStock-1-city-apartments.jpg',
        datePosted: '20/09/2018',
        description: 'Here, Switch2 are interrogating the information we process on your billing consumers and highlighting issues that could be concerning, such as estimated billing.'
      },
      {
        status: 'Expected',
        monthAndYear: '01/03',
        year: '2019',
        title: 'Issues - Metering',
        imageUrl: '/images/iStock--city-apartments.jpg',
        datePosted: '20/09/2018',
        description: 'Want to know what issues you could have on your metering network, visit here. We\'ll show you key possible concerns such as not communnicating and not showing consumption meters.'
      },
      {
        status: 'Expected',
        monthAndYear: '01/03',
        year: '2019',
        title: 'Meter and Consumption',
        imageUrl: '/images/iStock--Double-Thermometer.jpg',
        datePosted: '20/09/2018',
        description: 'Want to be able to get access to your meter reads, visit here. However, we hope more interesting for you, you can see the consumption history of your schemes, property consumption against scheme averagaes and so on so forth.'
      },


    ];

    this.filteredRoadMaps = this.roadMaps;

    this.completed = this.roadMaps.filter(x => x.status == 'Completed' || x.status == 'Partially completed');
    this.expected = this.roadMaps.filter(x => x.status == 'Expected');
    this.ideas = this.roadMaps.filter(x => x.status == 'Ideas');

    this.filterList.push(
      {
        key: "completed",
        label: "Completed",
        amount: this.completed.length,
        isClicked: false,
        data: this.completed
      },
      {
        key: "expected",
        label: "Expected",
        amount: this.expected.length,
        isClicked: false,
        data: this.expected
      },
      {
        statusType: 3,
        key: "ideas",
        label: "Ideas",
        amount: this.ideas.length,
        isClicked: false,
        data: this.ideas
      },
    )


  }

  ngOnDestroy() {
  }

}
